<!--<app-formgrid-label label="CONTACT_EMAILADDRESS"/>-->
<div class="flex align-items-center gap-2">
  <div class="flex flex-1" [class.p-inputgroup]="!mailVerified || (mailVerified || verificationMailSent)">
    <input type="text" pInputText class="p-inputtext flex-1"
           (blur)="trimField()"
           [(ngModel)]="mailAddress"
           (ngModelChange)="mailAddressChange.emit(mailAddress)"
           [disabled]="verificationMailSent || mailVerified" [class.disabled]="verificationMailSent || mailVerified"
           [maxlength]="255"
           [placeholder]="(placeholder ? placeholder : ((showMailVerificationTip && !view.isMobile) ? 'MAIL_ADDRESS_VERIFICATION_TIP' : '')) | translate"
           (keydown.enter)="requestConfirmationCode()">

    @if (mailVerified || verificationMailSent) {
      <p-button icon="pi pi-trash" class="nowrap-button" (click)="resetMail()"/>
    }
    @if (!mailVerified) {
      <p-button icon="pi pi-send" class="nowrap-button"
                [disabled]="isVerifyingMail || mailVerified || verificationMailSent || !mailAddress || !mailAddress.includes('@')" [loading]="isVerifyingMail"
                [label]="'SEND_VERIFICATION_CODE' | translate"
                (click)="requestConfirmationCode()"/>
    }
  </div>
  <i [class]="mailStatusIcon" [pTooltip]="mailStatusTooltip | translate" [showDelay]="400"></i>
</div>
@if (showMailVerificationTip && view.isMobile && !mailVerified) {
  <div [class]="'pt-2 font-italic ' + showMailVerificationTipColor">
    {{ 'MAIL_ADDRESS_VERIFICATION_TIP' | translate }}
  </div>
}
@if ((showInputAlways || (verificationMailSent && !mailVerified)) && !mailVerified) {
  <div class="pt-2 md:pt-3 flex align-items-center gap-2 flex-column md:flex-row"
       [class.text-gray-500]="!verificationMailSent">
    <span>
      {{'VERIFICATION_CODE' | translate}}:
    </span>
    <div class="flex align-items-center gap-2">
      <p-inputOtp [(ngModel)]="mailVerificationCode" [length]="6" (onChange)="verificationCodeChanged()"
                  [disabled]="!verificationMailSent || isVerifyingMailCode || mailVerified"
                  (onBlur)="mailVerificationCode = mailVerificationCode.toUpperCase()"/>
      @if (!mailVerified) {
        <p-button (onClick)="mailVerificationCode = ''" styleClass="p-button-text p-button-danger"
                  icon="pi pi-eraser" [disabled]="!mailVerificationCode"/>
      }
    </div>
  </div>
}

@if (mailReturnMessage) {
  <div class="pt-2 md:pt-3">
    <app-message [active]="true" [message]="mailReturnMessage"/>
  </div>
}
